import { useEffect, useRef, useState} from 'react'
import Template from './../../Template'
import * as SG from '../../../style/Styles'
import * as TXT from './../../../util/Texts'
import BlockGame from '../../../components/game/BlockGame'
import { CalendarIcon } from './../../../components/material/icons'
import * as GameService from './../../../services/Game.service'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../../util/AlertsMsg'
import * as F from './../../../util/Functions'

export default function Results() {

  const calendar                        = useRef<any>()
  const [matchs, setMatchs]             = useState<any>([])
  const [results, setResults]           = useState<any>([])
  const [teams, setTeams]               = useState<string[]>([])
  const [dateFilter, setDateFilter]     = useState<any>('');
  const [reloadMatchs, setReloadMatchs] = useState<boolean>(false);

  const getGamesData = (dateFil:any) => { 
 
    const dataT =  dateFil ?? F.formatUSData( F.getLocalDateForCountry() )
    setDateFilter(dataT < TXT.STARTED_DAY ? TXT.STARTED_DAY : dataT)
    getGamers(dataT < TXT.STARTED_DAY ? TXT.STARTED_DAY : dataT)

    return
  }

  const getGamers = async (dateF:string) => {
    
    const result = await GameService.GetGamesByDate(dateF)

    if (result.data) {
      if (result.data.status) {
        setTeams(result.data.teams)
        setMatchs(result.data.games)
        setResults(result.data.results)
      } else {

        try {
          ERROR_ALERT(result.response.data.message)
        } catch (error) {
          console.warn(error)
          ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
        }
      }

    } else {
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
    }
  }

  const handleSend = async () =>{

    const data:any = {user_id: F.GetIDUser(), results: results}
    const result   = await GameService.UpdateGames(data)

    if (result.data && result.data.status) {
      SUCCESS_ALERT(result.data.message)
    } else {
     
      try {
        ERROR_ALERT(result.response.data.message)
      } catch (error) {
        console.warn(error)
        ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      }
    }

    return
  }

  const openCalendar = () => {

    if (calendar.current)
      calendar.current.focus()

    return
  }
  
  useEffect(()=>{

    getGamesData(null)
    
  }, [])

  useEffect(()=>{

    if(reloadMatchs === true) {
      getGamesData(dateFilter)
      setReloadMatchs(false)
    }

  },[reloadMatchs])

  return (
    <Template>

      <SG.Title className='titleResuls upperCase' style={{textAlign:'center'}}>{TXT.RESULTS}</SG.Title>

      <SG.PADD>
        <SG.Div className='contentResults'>
          <SG.BoxGrey className='boxResults'>
            <SG.DATA_GAME>
              <SG.Text 
                style={{ display:'flex', justifyContent:'center', alignItems:'center', fontSize:18}}
                onClick={openCalendar}
              > 
                <CalendarIcon />  
                {TXT.MATCH_DATE}

                <SG.InputDate 
                  ref={calendar}
                  type='date'
                  name='dataF'
                  value={dateFilter}
                  onChange={(e)=>{getGamesData(e.target.value)}}
                />
                
              </SG.Text>
            </SG.DATA_GAME>

            <SG.BoxBlocks>
              {matchs.length > 0 && matchs.map((game:any, i:any) => (
                <BlockGame
                    key={i}
                    id={game.id}
                    infosData={game.infosMatch}
                    teamHome={F.translateTeamName(game.home_team)}
                    teamVisit={F.translateTeamName(game.visiting_team)}
                    iconHome={game.home_team_icon}
                    iconVisit={game.visiting_team_icon}
                    homeID={game.home_team_id}
                    VisitID={game.visiting_team_id}
                    resultMatch={results}
                    setResultMatch={setResults}
                    isResult={true}
                    teams={teams}
                    setReloadMatchs={setReloadMatchs}
                  />
              ))}
            </SG.BoxBlocks>
          </SG.BoxGrey>

          <SG.PrimaryButtom
            className='btnResults'
            onClick={handleSend}
          >
            {TXT.SAVE_RESULT}
          </SG.PrimaryButtom>
        </SG.Div>
      </SG.PADD>
        
    </Template>
  );

}

  